import { views } from '../constants';
const { ALL_ITEMS, ALERTS } = views;

export default (body, view) => {
    const { GiftList } = body || {};

    if (view === ALL_ITEMS || view === ALERTS) return true;

    if (!GiftList || GiftList.length === 0 || !GiftList[0].callerOwns) {
        return false;
    } else {
        return GiftList[0].callerOwns.toLowerCase() === 'true'; //TODO update when api returns boolean instead of string
    }
};
